const EASTERN_TIME_ZONE = 'America/New_York';

const easternTimeZoneLabelFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: EASTERN_TIME_ZONE,
  timeZoneName: 'short',
});

const easternTimeFirstDateTimeFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: EASTERN_TIME_ZONE,
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});

function getDateTimePart(
  parts: Intl.DateTimeFormatPart[],
  type: Intl.DateTimeFormatPartTypes,
) {
  return parts.find((part) => part.type === type)?.value ?? '';
}

function getEasternTimeZoneLabel(currentDate: Date) {
  const timeZoneName =
    easternTimeZoneLabelFormatter
      .formatToParts(currentDate)
      .find((part) => part.type === 'timeZoneName')?.value ?? '';

  return timeZoneName === 'EDT' ? 'EDT' : 'EST';
}

export function formatEasternTimeFirstDateTime(
  value: Date | string | number | null | undefined,
  currentDate = new Date(),
) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  const parts = easternTimeFirstDateTimeFormatter.formatToParts(
    new Date(value),
  );
  const month = getDateTimePart(parts, 'month');
  const day = getDateTimePart(parts, 'day');
  const year = getDateTimePart(parts, 'year');
  const hour = getDateTimePart(parts, 'hour');
  const minute = getDateTimePart(parts, 'minute');
  const dayPeriod = getDateTimePart(parts, 'dayPeriod');
  const timeZone = getEasternTimeZoneLabel(currentDate);

  return `${month} ${day}, ${year} at ${hour}:${minute} ${dayPeriod} ${timeZone}`;
}

export function formatRelativeTime(timestamp: number) {
  const now = Date.now();
  const diff = now - timestamp;
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days}d ago`;
  if (hours > 0) return `${hours}h ago`;
  if (minutes > 0) return `${minutes}m ago`;
  return `${seconds}s ago`;
}

export function downloadFile(data: string, filename: string, mimeType: string) {
  const blob = new Blob([data], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** `v1.2.3 (45)`, `v1.2.3`, `code 45`, or a placeholder when neither is known. */
export function formatVersionLabel(
  name: string | null | undefined,
  code?: number | null,
): string {
  if (name) {
    const version = /^v/i.test(name) ? name : `v${name}`;
    return code != null ? `${version} (${code})` : version;
  }
  if (code != null) return `code ${code}`;
  return 'Unknown version';
}
